import React, { useState } from 'react';
import {
    Box,
    Typography,
    Card,
    CardContent,
    Button,
    Switch,
    FormControlLabel,
} from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { Tv, WashingMachine, Utensils, Droplets } from 'lucide-react';

const DeviceModel = ({ onNext, onBack, selectedDevices = [], onDevicesSelected }) => {
    const theme = useTheme();
    const [localSelectedDevices, setLocalSelectedDevices] = useState({
        TV: false,
        Dish_Washer: false,
        Washing_Machine: false,
        Washer_Dryer: false,
    });

    // Initialize local state from props
    React.useEffect(() => {
        if (selectedDevices.length > 0) {
            const deviceState = {
                TV: selectedDevices.includes('TV'),
                Dish_Washer: selectedDevices.includes('Dish_Washer'),
                Washing_Machine: selectedDevices.includes('Washing_Machine'),
                Washer_Dryer: selectedDevices.includes('Washer_Dryer'),
            };
            setLocalSelectedDevices(deviceState);
        }
    }, [selectedDevices]);

    const handleSwitchChange = (device) => (event) => {
        const newDeviceState = {
            ...localSelectedDevices,
            [device]: event.target.checked,
        };
        setLocalSelectedDevices(newDeviceState);

        // Convert to array format and send to parent
        const selectedDeviceArray = Object.entries(newDeviceState)
            .filter(([key, value]) => value)
            .map(([key]) => key);

        onDevicesSelected(selectedDeviceArray);
    };

    const deviceCards = [
        {
            id: 'TV',
            title: 'TV',
            icon: <Tv size={40} />,
        },
        {
            id: 'Dish_Washer',
            title: 'Dishwasher',
            icon: <Utensils size={40} />,
        },
        {
            id: 'Washing_Machine',
            title: 'Washing Machine',
            icon: <WashingMachine size={40} />,
        },
        {
            id: 'Washer_Dryer',
            title: 'Washer/Dryer',
            icon: <Droplets size={40} />,
        },
    ];

    const hasSelectedAtLeastOne = Object.values(localSelectedDevices).some((value) => value);

    return (
        <Box>

            <Box display="flex" flexDirection="row" gap={2} sx={{ mt: 1 }}>
                {deviceCards.map((device) => (
                    <Card
                        key={device.id}
                        sx={{
                            flex: 1,
                            backgroundColor: localSelectedDevices[device.id]
                                ? alpha(theme.palette.primary.main, 0.2)
                                : 'inherit',
                        }}
                    >
                        <CardContent>
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                            >
                                <Box display="flex" alignItems="center">
                                    {device.icon}
                                    <Typography variant="h6" sx={{ ml: 1 }}>
                                        {device.title}
                                    </Typography>
                                </Box>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={localSelectedDevices[device.id]}
                                            onChange={handleSwitchChange(device.id)}
                                            color="primary"
                                        />
                                    }
                                    label=""
                                />
                            </Box>
                        </CardContent>
                    </Card>
                ))}
            </Box>

            <Box sx={{ mt: 4 }}>
                <Button onClick={onBack} variant="text">
                    Back
                </Button>
                <Button
                    onClick={() => {
                        // Convert to array format for the API call
                        const selectedDeviceArray = Object.entries(localSelectedDevices)
                            .filter(([key, value]) => value)
                            .map(([key]) => key);

                        console.log('Selected devices:', selectedDeviceArray);
                        onNext();
                    }}
                    variant="outlined"
                    color="primary"
                    sx={{ ml: 2 }}
                    disabled={!hasSelectedAtLeastOne}
                >
                    Next
                </Button>
            </Box>
        </Box>
    );
};

export default DeviceModel;
